<div fxLayout="row">
  <div fxFlex="100" class="outer-align align-right">
    <img class="close" [mat-dialog-close] src="../../../assets/icons/cancel.svg" />
  </div>
</div>

<iframe #iframe width="100%" height="100%" frameBorder="0" [src]="urlSafe"></iframe>
